export type Registre = {
    id: number;
    moment: string;
    tipus: number;
    lloc: string;
}

export const defaultRegistre: Registre = {
    id: 0,
    moment: "",
    tipus: 0,
    lloc: "",
};
